export const cnaeNumerico = (cnae: string): string => {
    let numbers = cnae.replace(/\D/g, '');

    if (numbers.length < 7) {
        const zeros = '0'.repeat(7 - numbers.length);
        numbers = zeros + numbers;
    }

    return numbers;
};